












































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import ZipUtil from "@/script/zipUtil";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import Toast from "@/script/message";
import {eGameStage} from "@/common/enumData";
import Version from "@/script/version";

@Component({
    components: {ClipLoader},
})
export default class AddGameFile extends Vue {
    @Prop() isEditProject !: any;
    eGameStage = eGameStage;
    projectId = this.$route.params.id;

    toast = new Toast();
    limitSize: number = 1024 * 1000 * 500;
    totalSize: number = 0;
    uploadGameFile: File | null = null;
    uploadGameFiles: File[] = [];
    isAdvancedOpen: boolean = false;
    startFile: string = '';
    startFileOptions: string[] = [];

    fileName: string = '';
    versionDescription: string = "";

    isLoadingFile: boolean = false;
    autoDeploy: boolean = true;

    isFileEmpty: boolean = false;
    isLoadingUpload: boolean = false;

    mounted() {
        this.init();
    }

    init() {
        this.isLoadingUpload = false;
        this.uploadGameFiles = [];
        this.$store.commit('uploadGameFiles', [])
    }

    async onFileChange(e) {

        this.uploadGameFile = e.target.files[0];

        this.isLoadingFile = true;
        const zip = await ZipUtil.zipFileToZip(this.uploadGameFile);

        const files: any = await ZipUtil.zipToFiles(zip);
        let size: number = 0;

        for (let f in files) {
            size += files[f].size;
        }

        if (size > this.limitSize) {
            alert('500mb 초과')
            return;
        }

        this.totalSize = Number((size / (1024 * 1000)).toFixed(2));
        this.uploadGameFiles = files;

        const htmls = this.uploadGameFiles.filter((file) => {
            return file.name.indexOf('.html') > -1;
        });

        this.startFileOptions = htmls.map(file => file.name);
        this.startFileOptions.sort((a, b) => a.length - b.length);
        const indexFiles = this.startFileOptions.filter(name => name.includes('index'));

        if (indexFiles.length) {
            indexFiles.sort((a, b) => a.length - b.length);
            this.startFile = indexFiles[0];
        }
        else {
            this.startFile = this.startFileOptions[0];
        }

        this.startFileOptions.sort((a, b) => a.length - b.length);

        if (this.startFileOptions.length) {
            // this.uploadGameFileError = '';
            this.fileName = e.target.files[0].name
        }
        else {
            alert(`${this.$t('notFoundHtml')}`)
            this.fileName = ''
            // this.uploadGameFileError = this.$t('projectAddVersion.error.notFoundHtml').toString();

        }
        if (
            this.uploadGameFiles.length > 0 &&
            this.startFileOptions.length > 0
        ) {
            this.$store.commit("sendGameFileDone", true);

            this.$store.commit("uploadGameFiles", this.uploadGameFiles);
            this.isFileEmpty = false;
        }
        else {
            this.$store.commit("sendGameFileDone", false);
        }

        this.isLoadingFile = false;
    }

    deleteFile() {
        this.$store.commit("uploadGameFiles", []);
        this.uploadGameFile = null;
        this.uploadGameFiles = [];
        this.startFile = '';
        this.startFileOptions = [];
        this.totalSize = 0;
        this.fileName = '';
        (this.$refs.gameFile as any).value = '';
    }

    upload() {
        if (this.isLoadingUpload) {
            return;
        }


        const {uploadGameFiles, gameStage} = this.$store.getters;

        if (gameStage !== eGameStage.Dev) {
            if (!uploadGameFiles) {
                this.isFileEmpty = true;
            }
            else if (uploadGameFiles && uploadGameFiles.length === 0) {
                this.isFileEmpty = true;
            }
            else{
                this.isLoadingUpload = true;
                this.createProject();
            }

        }
        else {
            this.isLoadingUpload = true;
            this.createProject();
            this.isFileEmpty = false;
        }


    }

    createProject() {
        const {gameInfoObj, uploadGameFiles, gameStage} = this.$store.getters;


        const gameFileInfo = {
            autoDeploy: gameStage === eGameStage.Dev ? false : this.autoDeploy,
            startFile: this.startFile,
            size: this.totalSize,
            version_description: this.versionDescription,
        };
        this.$api.createProject(
            gameInfoObj,
            gameFileInfo,
            uploadGameFiles
        )
            .then((res) => {
                this.toast.successToast(`${this.$t('gameUpload.done')}`);
                this.$router.push(`/${this.$i18n.locale}/projectList`)

            })
            .catch((err) => {
            })
            .finally(() => {
                this.isLoadingUpload = false;
            })
    }

    async updateProject() {
        const {gameStage} = this.$store.getters;
        if (this.isLoadingUpload) {
            return;
        }


        let isError = false;

        if (gameStage !== eGameStage.Dev) {
            if (!this.uploadGameFiles.length) {
                isError = true;
                this.isFileEmpty = true;
            }


            if (!this.startFileOptions.length) {
                isError = true;
            }

            if (isError) {
                // this.wait = false;
                return;
            }
        }
        else {
            this.isFileEmpty = false;
        }
        this.isLoadingUpload = true;

        const option: any = {
            id: this.projectId,
            name: localStorage.getItem('title'),
            description: localStorage.getItem('description'),
            hashtags: localStorage.getItem('hashtagsArr'),
            stage: this.$store.getters.gameStage
        };

        if (this.$store.getters.gameStage === eGameStage.Dev) {
            this.autoDeploy = false;
        }

        this.$api.updateProject(option, this.$store.getters.thumbFile)
            .then((res) => {
                // this.toast.successToast("게임이 업로드되었습니다.");
                // this.$router.push('/projectList')
            })
            .catch((err) => {
                console.log('err', err)
                return;
            })
            .finally(() => {
                this.isLoadingUpload = false;
            })
        if(this.uploadGameFiles && this.uploadGameFiles.length > 0) {
            const version = await this.$api.createVersion(this.projectId, '1.0.0', this.uploadGameFiles, this.startFile,
            this.autoDeploy, this.totalSize, '', this.$store.getters.gameStage);
        }
        await this.$router.replace(`/${this.$i18n.locale}/projectList`);
    }

    prevPage() {
        this.$emit('gameInfoDone', false)
    }

}
